// exports PracticeValidationStatus - an immutable object 'enum'
// usage: import { PracticeValidationStatus } from '../../enums/PracticeValidationStatus';
const packageType = {
    Normal: 1,
    PrePrint_Remote: 2,
    Hybrid: 3
};
Object.freeze(packageType);
export const PackageType = packageType;